import { render } from "./z-delete-team-member-modal.vue?vue&type=template&id=5c451149"
import script from "./z-delete-team-member-modal.vue?vue&type=script&lang=js"
export * from "./z-delete-team-member-modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__